import React, { Component } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import jwtDecode from "jwt-decode";
import Axios from "axios";
import Pagination from "@material-ui/lab/Pagination";

import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import EmptyMessage from "../../../Assets/Images/emptyMessage.png";
import { connect } from "react-redux";
import { url } from "../../../config/config";
import MessageBody from "./MessageBody/MessageBody";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./AuthorMessage.css";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a1f3a",
    },
  },
});

class AuthorMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      isEmpty: false,
      expanded: "",
      messageCount: 0,
      currentPage: 1,
      postPerPage: 6,
    };
  }

  componentDidMount() {
    this.getMessage();
    this.getMessageLength();
  }

  getMessage = async () => {
    let decodeData = jwtDecode(this.props.authorToken);
    const response = await Axios.get(
      `${url}/api/messages/author/${decodeData._id}`,
      {
        headers: {
          "x-auth-token": this.props.authorToken,
        },
      }
    );
    if (response.data.messages.length !== 0) {
      this.setState({
        messages: response.data.messages,
        isEmpty: false,
      });
    } else {
      this.setState({
        messages: [],
        isEmpty: true,
      });
    }
  };

  getMessageLength = async () => {
    let decodeData = jwtDecode(this.props.authorToken);
    const response = await Axios.get(
      `${url}/api/messages/author/${decodeData._id}`,
      {
        headers: {
          "x-auth-token": this.props.authorToken,
        },
      }
    );
    let newCount = response.data.messages.filter(
      (message) => message.seenByAuthor === false
    );
    this.setState({
      messageCount: newCount.length,
    });
  };

  handleDelete = async (messageId) => {
    const response = await Axios.delete(`${url}/api/messages/${messageId}`, {
      headers: {
        "x-auth-token": this.props.authorToken,
      },
    });
    if (response.data.success) {
      this.getMessage();
      this.getMessageLength();
    }
  };

  handleClick = async (message) => {
    if (message.seenByAuthor === false) {
      const response = await Axios.put(
        `${url}/api/messages/read/${message._id}`,
        null,
        {
          headers: {
            "x-auth-token": this.props.authorToken,
          },
        }
      );
      if (response.data) {
        this.getMessage();
        this.getMessageLength();
      }
    }
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  compare = (a, b) => {
    const nameA = a.createdAt;
    const nameB = b.createdAt;

    let comparison = 0;
    if (nameA < nameB) {
      comparison = 1;
    } else if (nameA > nameB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes } = this.props;
    this.state.messages.sort(this.compare);
    const { currentPage, postPerPage } = this.state;
    return (
      <div>
        <Header messageCount={this.state.messageCount} />
        <div className={classes.root}>
          {this.state.messages.length !== 0 ? (
            <div>
              <div style={{ fontSize: 24 }}>My Messages</div>
              <Divider />
              <br />
              <MessageBody
                currentPage={currentPage}
                postPerPage={postPerPage}
                messages={this.state.messages}
                handleClick={this.handleClick}
                handleDelete={this.handleDelete}
              />
              <div className={classes.paginationStyle}>
                <ThemeProvider theme={theme}>
                  <Pagination
                    count={Math.ceil(this.state.messages.length / postPerPage)}
                    color="primary"
                    page={currentPage}
                    boundaryCount={1}
                    onChange={this.handlePage}
                    showFirstButton
                    showLastButton
                  />
                </ThemeProvider>
              </div>
            </div>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage
              message="There is no any messages recieved."
              image={EmptyMessage}
            />
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorToken: state.AuthorReducer.authorToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(AuthorMessage));
